/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Home_Offerhover_Moregenres2Inputs */

const id_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("id", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} lainnya`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} lainnya`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const ms_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ms", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} lagi`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} lagi`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const da_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("da", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} mere`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} mere`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const de_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} mehr`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} mehr`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const en_us2_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en-US", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} more`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} more`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const es_es2_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-ES", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} más`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} más`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const es_mx2_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-MX", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} más`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} más`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const fil_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fil", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} pa`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} pa`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const fr_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} supplémentaire`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} supplémentaires`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const it_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} altro`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} altri`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const hu_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} további`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} további`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const nl_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} meer`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} meer`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const no_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("no", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} til`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} til`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const pl_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} więcej`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} więcej`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const pt_br2_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} mais`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} mais`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const pt_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} mais`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} mais`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const ro_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ro", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} mai mult`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} mai multe`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const fi_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} lisää`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} lisää`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const sv_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("sv", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} mer`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} fler`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const vi_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("vi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} thể loại khác`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} thể loại khác`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const tr_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("tr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} tür daha`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} tür daha`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const cs_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("cs", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} další`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} dalších`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const bg_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("bg", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} още`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} още`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const ru_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ru", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`и ещё +${i?.count}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`и ещё +${i?.count}`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const uk_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("uk", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`ще +${i?.count}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`ще +${i?.count}`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const ar_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ar", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} المزيد`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} المزيد`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const hi_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} और`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} और`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const th_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("th", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`อีก +${i?.count}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`อีก +${i?.count}`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const ja_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`他+${i?.count}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`他+${i?.count}`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const zh_cn2_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-CN", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} 个更多`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} 个更多`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const zh_hant1_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-Hant", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count} 個更多`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count} 個更多`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

const ko_home_offerhover_moregenres2 = /** @type {(inputs: Home_Offerhover_Moregenres2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ko", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`+${i?.count}개 더`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`+${i?.count}개 더`);
	return /** @type {LocalizedString} */ ("home.offerHover.moreGenres");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "+{count} more" |
* | "other" | "+{count} more" |
*
* @param {Home_Offerhover_Moregenres2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_offerhover_moregenres2 = /** @type {((inputs: Home_Offerhover_Moregenres2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Offerhover_Moregenres2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_offerhover_moregenres2(inputs)
	if (locale === "ms") return ms_home_offerhover_moregenres2(inputs)
	if (locale === "da") return da_home_offerhover_moregenres2(inputs)
	if (locale === "de") return de_home_offerhover_moregenres2(inputs)
	if (locale === "en-US") return en_us2_home_offerhover_moregenres2(inputs)
	if (locale === "es-ES") return es_es2_home_offerhover_moregenres2(inputs)
	if (locale === "es-MX") return es_mx2_home_offerhover_moregenres2(inputs)
	if (locale === "fil") return fil_home_offerhover_moregenres2(inputs)
	if (locale === "fr") return fr_home_offerhover_moregenres2(inputs)
	if (locale === "it") return it_home_offerhover_moregenres2(inputs)
	if (locale === "hu") return hu_home_offerhover_moregenres2(inputs)
	if (locale === "nl") return nl_home_offerhover_moregenres2(inputs)
	if (locale === "no") return no_home_offerhover_moregenres2(inputs)
	if (locale === "pl") return pl_home_offerhover_moregenres2(inputs)
	if (locale === "pt-BR") return pt_br2_home_offerhover_moregenres2(inputs)
	if (locale === "pt") return pt_home_offerhover_moregenres2(inputs)
	if (locale === "ro") return ro_home_offerhover_moregenres2(inputs)
	if (locale === "fi") return fi_home_offerhover_moregenres2(inputs)
	if (locale === "sv") return sv_home_offerhover_moregenres2(inputs)
	if (locale === "vi") return vi_home_offerhover_moregenres2(inputs)
	if (locale === "tr") return tr_home_offerhover_moregenres2(inputs)
	if (locale === "cs") return cs_home_offerhover_moregenres2(inputs)
	if (locale === "bg") return bg_home_offerhover_moregenres2(inputs)
	if (locale === "ru") return ru_home_offerhover_moregenres2(inputs)
	if (locale === "uk") return uk_home_offerhover_moregenres2(inputs)
	if (locale === "ar") return ar_home_offerhover_moregenres2(inputs)
	if (locale === "hi") return hi_home_offerhover_moregenres2(inputs)
	if (locale === "th") return th_home_offerhover_moregenres2(inputs)
	if (locale === "ja") return ja_home_offerhover_moregenres2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_offerhover_moregenres2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_offerhover_moregenres2(inputs)
	return ko_home_offerhover_moregenres2(inputs)
});
export { home_offerhover_moregenres2 as "home.offerHover.moreGenres" }